import req from '@/utils/req.js'


//病种
// export function termListData(params) {
//     return req.post(`/admin/disease-type/listHideCommon`, params)
// }

//病种
export function termListData(params) {
    return req.get(`/admin/disease-type`, params)
}

//机构
export function hospitalList(params) {
    return req.get(`/admin/hospital`, params)
}

//线下团队
export function doctorList(params) {
    return req.get(`/admin/doctor-team/listHasTeamService`, params)
}
//选择服务权益列表
export function getTeamServicePage(params) {
    return req.post("/admin/team-service/getTeamServicePage", params)
}

//获取自定义颜色
export function categoryList(params) {
    return req.get(`/admin/category/${params.code}/children`, params)
}

//落地页保存第一步
export function pagelandSave(params) {
    return req.post("/admin/landing-page/save", params)
}

//落地页保存第二步
export function pagelandSaveContent(params) {
    return req.post("/admin/landing-page/saveContent", params)
}


//选择服务权益列表
export function pageList(params) {
    return req.post("/admin/landing-page/page", params)
}


//选择服务权益列表
export function pagelandList(params) {
    return req.post("/dsicm-data-base/feign/landing-page/page", params)
}

//落地页发布
export function publish(params) {
    return req.put(`/admin/landing-page/publish`, params);
}

//删除落地页
export function pagelandDelete(params) {
    return req.delete(`/admin/landing-page/${params.id}`)
}

//落地页详情
export function pagelandDetail(params) {
    return req.get(`/admin/landing-page/${params.id}`, params)
}


// //提交颜色
// export function description(params) {
//     return req.put(`/admin/category/description`, params);
// }

//选择服务
export function therapistByDiseaseId(params) {
    return req.get(`/admin/team-service/therapistByDiseaseId`, params)
}

//查找已经被使用过的疾病类型
export function listUsedDiseaseType(params) {
    return req.get(`/admin/landing-page/listUsedDiseaseType`, params)
}


//查找已经被使用过的疾病类型
export function getDiseaseIdListById(params) {
    return req.get(`/admin/doctor-team/getDiseaseIdListById`, params)
}



//提交颜色
export function description(params) {
    return req.put(`/admin/landing-page/buttonPreference`, params);
}

//落地页id判断商品是否下架
export function getLandingpageGoodsStatusByLandingPageId(params) {
    return req.get(`/biz/landingpage-goods-relation/getLandingpageGoodsStatusByLandingPageId/`, params)
}


//落地页商品列表
export function shopPage(params) {
    return req.get(`/biz/dsicm-goods/page`, params)
}

//落地页商品详情
export function shopDetail(params) {
    return req.get(`/biz/dsicm-goods/${params.goodId}`, params)
}


